module.exports = __webpack_public_path__ + "static/LOGO@3x-0df7863eee3db8b38c2b1642fc69ea8b.png";